module.exports = __webpack_public_path__ + "img/pic_youshi_02.1905f6b8.png";